import React, { useContext, useState } from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import styles from './styles.module.css'
import PrimaryButton from '../../../../../../../../../global/components/buttons/primary-button/PrimaryButton'
import SecondaryButton from '../../../../../../../../../global/components/buttons/secondary-button/SecondaryButton'
import CircularProgress from '@mui/material/CircularProgress'
import { fetchData } from '../../../../../../../../../global/utils/fetch'
import { deleteCase } from '../../api'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { DeleteResult } from 'typeorm'
import { ToastNotificationContext } from '../../../../../../../../../global/context/ToastNotificationContext'

interface ICaseDeleteProps {
  isOpen: boolean
  handleClosedSuccess: Function
  handleClosed: Function
  caseObjectId: string
}
export default function DeleteConfirmationModal(props: ICaseDeleteProps) {
  const { user } = useAuthenticator((context) => [context.user])
  const { toastStatus, setToastStatus } = useContext(ToastNotificationContext)

  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const handleDeleteCase = async () => {
    try {
      setIsLoading(true)
      await fetchData<DeleteResult>(deleteCase(props.caseObjectId))
      props.handleClosedSuccess()
      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: 'Successfully deleted case!',
        severity: 'success',
      })
    } catch (err) {
      console.error(err)
      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: 'There has been an error deleting case.',
        severity: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <Modal
        open={props.isOpen}
        onClose={() => props.handleClosed()}
      >
        <Box className={styles.deleteCaseModal}>
          <div className={`${styles.deleteCaseModalPageTitle} font--bold`}>
            Are you sure you want to delete Case?
          </div>
          {isLoading && (
            <div className={styles.progressContainer}>
              <CircularProgress />
            </div>
          )}
          {isError && (
            <div className={styles.errorMessage}>Error deleting case</div>
          )}
          <div className={styles.buttonContainer}>
            <SecondaryButton
              buttonName='Cancel'
              onClick={() => props.handleClosed()}
            />
            <PrimaryButton
              disabled={isLoading}
              buttonName='Yes, delete'
              onClick={handleDeleteCase}
            />
          </div>
        </Box>
      </Modal>
    </div>
  )
}
